/** 
 *   商品管理 api
 */
import { get, post, put, del } from '@/untils/axios.js'


/*
 *   分类管理
 */
// 分类列表
export const classify_list = params => get('goods/type', params)
// 添加分类
export const classify_add  = params => post('goods/type', params)
// 修改分类
export const classify_put  = (id,params) => put(`goods/type/${id}`, params)
export const classif_put  = (id,params) => put(`section/${id}`, params)
// 删除分类
export const classify_del  = id => del(`goods/type/${id}`)


/*
 *   品牌管理
 */
// 品牌列表
export const brand_list = params => get('brand', params)
// 添加品牌
export const brand_add  = params => post('brand', params)
// 修改品牌
export const brand_put  = (id,params) => put(`brand/${id}`, params)
// 删除品牌
export const brand_del  = id => del(`brand/${id}`)



/*
 *   自营商品
 */
// 商品列表
export const goods_list = params => get('goods', params)

// 批量修改分类  商品列表
export const goods_classify_list = params => get('goods/type-goods-list', params)
// 批量修改分类
export const goods_classify_edit = params => post('goods/type-goods-update', params)
// 删除商品分类
export const goods_classify_del  = params => get('type_del', params)


/*
 *   预售商品
 */
// 预售商品列表
export const presell_goodsList = params => get(`pre_manage_list`, params)
// // 预售商品修改
// export const presellGoods_put    = (id,params) => put(`goods/${id}`, params)
// 预售批次列表
export const batch     = params => get('presale/batch', params)
// 预售批次添加
export const batch_add = params => post('presale/batch', params)
// 预售批次修改
export const batch_put = (id,params) => put(`presale/batch/${id}`, params)

// 商品 添加
export const goods_add    = params      => post('goods', params)
// 商品 删除
export const goods_del    = id      => del(`goods/${id}`)
// 商品 修改状态
export const goods_status = (id,params) => put(`goods/${id}`, params)
//  未通过审核
export const goods_check_no = params => post('check_no', params)
// 商品 获取信息
export const goods_get    = (id,params) => get(`goods/${id}`, params)
// 商品 修改
export const goods_put    = (id,params) => put(`goods/${id}`, params)
// 商品 SKU
export const goods_sku    = id      => get(`goods/sku-list/${id}`)
// 商品 SKU修改
export const sku_update   = (id,params)      => post(`goods/sku-update/${id}`, params)
// 商品 SKU删除
export const sku_del      = id      => post(`goods/sku-del/${id}`)
// 商品  规格属性列表
export const attr_list    = id      => get(`goods/attr-list/${id}`)
// 商品  修改规格
export const attr_update  = (id,params)      => post(`goods/attr-update/${id}`,params)
// 商品  删除规格
export const attr_del     = id      => post(`goods/attr-del/${id}`)
// 商品  添加规格
export const attr_add     = params      => post(`goods/attr-add`, params)

// 自营订货商品搜素列表 
export const buy_list = params => post(`purchase/search/goods`, params)

// 商品评论 列表 
export const comment_list  = params      => get(`comment`, params)
// 商品评论 回复
export const comment_add   = params      => post(`comment/waiter/reply`, params)
// 商品评论 审核
export const comment_put   = (id,params) => put(`comment/${id}`, params)
// 商品评论 删除
export const comment_del   = params      => del(`comment/${params}`)

// 商品操作记录
export const record_list   = params => get(`goods_record`, params)

// 上传谷歌
export const add_google   = id => post(`google/shops-add-goods/${id}`)

// 下架谷歌
export const del_google   = id => post(`google/shops-del-goods/${id}`)

//  为你推荐 新品首发 热销产品 添加
export const add_columns  = params => post(`goods/columns`,params)

//  为你推荐 新品首发 热销产品 列表
export const goods_columns_list  = params => get(`goods/columns`,params)

//  为你推荐 新品首发 热销产品 列表
export const del_columns  = id => del(`goods/columns/${id}`)
//  为你推荐 新品首发 热销产品 列表
export const put_columns  = (id,params) => put(`goods/columns/${id}`,params)


//  商品 任务列表
export const task_list  = params => get(`/goods/auto/task`,params)

//  商品 任务添加
export const task_add  = params => post(`/goods/auto/task`,params)

//  商品 任务修改
export const task_put  = (id, params) => put(`/goods/auto/task/${id}`,params)

//  商品 任务删除
export const task_del  = id => del(`/goods/auto/task/${id}`)


/*
 *   添加关键字
 */

// 商品列表
export const search_goods  = params => get(`/search/goods`, params)

// 商品列表
export const words_put  = params => put(`/goods/update/keyword`, params)